import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=0e8a3fe8&scoped=true"
import script from "./BulkActions.vue?vue&type=script&lang=js"
export * from "./BulkActions.vue?vue&type=script&lang=js"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=0e8a3fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a3fe8",
  null
  
)

export default component.exports